export const DASHBOARD_RECENT_RECORDS_LIMIT = 5;

function encodePathValue(value) {
  return encodeURIComponent(String(value || '').trim());
}

function statusBadgeClass(kind, statusValue) {
  const status = String(statusValue || '').trim().toLowerCase();

  if (kind === 'profile') {
    const map = {
      verified: 'bg-success-subtle text-success',
      pending: 'bg-warning-subtle text-warning',
      verification: 'bg-warning-subtle text-warning',
      new: 'bg-info-subtle text-info',
      completed: 'bg-primary-subtle text-primary',
      limited: 'bg-secondary-subtle text-secondary',
      disabled: 'bg-danger-subtle text-danger',
    };

    return map[status] || 'bg-secondary-subtle text-secondary';
  }

  if (kind === 'document') {
    const map = {
      approved: 'bg-success-subtle text-success',
      verified: 'bg-success-subtle text-success',
      pending: 'bg-warning-subtle text-warning',
      review: 'bg-warning-subtle text-warning',
      rejected: 'bg-danger-subtle text-danger',
      declined: 'bg-danger-subtle text-danger',
      uploaded: 'bg-info-subtle text-info',
      submitted: 'bg-primary-subtle text-primary',
    };

    return map[status] || 'app-badge-disabled';
  }

  if (status === 'approved') {
    return 'bg-success-subtle text-success';
  }

  if (status === 'error' || status === 'failed') {
    return 'bg-danger-subtle text-danger';
  }

  if (status === 'processed') {
    return 'bg-primary-subtle text-primary';
  }

  return 'bg-secondary-subtle text-secondary';
}

function statusField(kind, value) {
  return {
    label: 'common.status',
    value: value || '-',
    badgeClass: statusBadgeClass(kind, value),
  };
}

function buildProfileRows(rows = []) {
  return rows.map((row) => ({
    key: row.key,
    to: row.id ? `/profiles/${encodePathValue(row.id)}` : '/profiles',
    title: row.name || '-',
    meta: row.email || '-',
    fields: [
      statusField('profile', row.status),
      { label: 'profiles.country', value: row.country || '-' },
      { label: 'profiles.created', value: row.createdAt || '-' },
    ],
  }));
}

function buildDocumentRows(rows = []) {
  return rows.map((row) => ({
    key: row.key,
    to: row.key ? `/documents?document=${encodePathValue(row.key)}` : '/documents',
    title: row.name || '-',
    meta: row.profileName || '-',
    fields: [
      statusField('document', row.status),
      { label: 'common.type', value: row.type || '-' },
      { label: 'documents.created', value: row.createdAt || '-' },
    ],
  }));
}

function buildTransactionRows(rows = []) {
  return rows.map((row) => ({
    key: row.key,
    to: row.id ? `/transactions/${encodePathValue(row.id)}` : '/transactions',
    title: row.profileName || row.reference || '-',
    meta: row.reference || '-',
    fields: [
      statusField('transaction', row.status),
      { label: 'transactions.amount', value: row.amountFormatted || '-', valueClass: 'fw-semibold' },
      { label: 'transactions.method', value: row.methodId || '-' },
      { label: 'transactions.created', value: row.createdAt || '-' },
    ],
  }));
}

export function buildDashboardRecentSections({
  profiles = [],
  documents = [],
  deposits = [],
  withdrawals = [],
} = {}) {
  return [
    {
      key: 'profiles',
      title: 'dashboard.recentProfiles',
      to: '/profiles',
      iconClass: 'ti ti-users',
      emptyLabel: 'dashboard.noRecentProfiles',
      rows: buildProfileRows(profiles),
    },
    {
      key: 'documents',
      title: 'dashboard.recentDocuments',
      to: '/documents',
      iconClass: 'ti ti-file-text',
      emptyLabel: 'dashboard.noRecentDocuments',
      rows: buildDocumentRows(documents),
    },
    {
      key: 'deposits',
      title: 'dashboard.recentDeposits',
      to: '/transactions?type=deposit',
      iconClass: 'ti ti-arrow-down-left-circle',
      emptyLabel: 'dashboard.noRecentDeposits',
      rows: buildTransactionRows(deposits),
    },
    {
      key: 'withdrawals',
      title: 'dashboard.recentWithdrawals',
      to: '/transactions?type=withdrawal',
      iconClass: 'ti ti-arrow-up-right-circle',
      emptyLabel: 'dashboard.noRecentWithdrawals',
      rows: buildTransactionRows(withdrawals),
    },
  ];
}
